

export const GET_ASSET_DATA = 'GET_ASSET_DATA'
export const GET_ASSET_DATA_SUCCESS = 'GET_ASSET_DATA_SUCCESS'
export const GET_ASSET_DATA_FAILURE = 'GET_ASSET_DATA_FAILURE'
export const CLEAN_MIDDLE_VIEW_DATA = 'CLEAN_MIDDLE_VIEW_DATA'

export const CLEAN_WAS_DART_UPDATED = 'CLEAN_WAS_DART_UPDATED'
export const SET_ASSET_UPDATED_BY_DART = 'SET_ASSET_UPDATED_BY_DART'